<!--
 * @Description: 
 * @Author: zml
 * @Date: 2023-03-21 11:49:51
 * @LastEditors: zml
 * @LastEditTime: 2025-08-18 12:10:57
-->
<template>
  <el-dialog @close="close" top="100px" :visible="visible" :close-on-click-modal="false" width="600px" append-to-body>
    <div class="login-title">
      <div class="title">{{$hs("注册","Register") }}</div>
    </div>
    <div class="form-box">
      <el-form :model="formData" ref="formData" label-position="top" label-width="175px" :rules="rules">
        <!-- <div class="row"> 用户名
          <el-form-item prop="userAccount" :label="$t('GA.UserAccount') + ':'">
            <el-input ref="userAccount" v-model="formData.userAccount" @blur="userAccountBlur"></el-input>
            <span class="describe">
              <span
                style="color: red;"
                v-if="isUserAccount"
              >{{ $hs('用户名已存在','User name already exists','El nombre de usuario ya existe') }}&nbsp;&nbsp;</span>
              <span>{{$t('GA.LoginOnly')}}</span>
            </span>
          </el-form-item>
        </div>-->
        <el-form-item prop="email" :label="$t('GA.Email') + ':'" required>
          <el-input ref="inputEmail" v-model="formData.email"></el-input>
        </el-form-item>
        <el-form-item prop="userName" :label="$t('GA.Name') + ':'" required>
          <el-input v-model="formData.userName"></el-input>
        </el-form-item>
        <el-form-item prop="userPassword" :label="$t('GA.password') + ':'" required>
          <el-input type="password" v-model="formData.userPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="userPasswordVerify" :label="$t('GA.confirmPassword') + ':'" required>
          <el-input type="password" v-model="formData.userPasswordVerify" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="gender" :label="$t('GA.gender') + ':'" required>
          <el-radio-group v-model="formData.gender" style="width:350px">
            <el-radio :label="1">{{$t('GA.man')}}</el-radio>
            <el-radio :label="2">{{$t('GA.woman')}}</el-radio>
            <el-radio :label="0">{{$hs('保密','Secrecy','Confidencialidad')}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item prop="source" :label="$t('GA.customerSource') + ':'">
          <el-select allow-create filterable default-first-option clearable v-model="formData.source" placeholder @blur="sourceBlur">
            <el-option v-for="(item, index) in sourceList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>-->
        <!-- <el-form-item prop="userId" :label="$t('GA.salesman') + ':'">
          <el-select v-model="formData.userId" placeholder="NONE">
            <el-option v-for="(item, index) in userList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item prop="country" :label="$t('GA.Country') + ':'" required>
          <el-input v-model="formData.country"></el-input>
        </el-form-item>
        <el-form-item prop="company" :label="$t('GA.companyName') + ':'" required>
          <el-input v-model="formData.company"></el-input>
        </el-form-item>
        <!-- <div class="row"> 职务
          <el-form-item prop="job" :label="$t('GA.duty') + ':'">
            <el-input v-model="formData.job"></el-input>
            <span class="describe"></span>
          </el-form-item>
        </div>-->
        <el-form-item prop="tel" :label="$t('GA.tel') + ':'" required>
          <el-input v-model="formData.tel"></el-input>
        </el-form-item>
        <el-form-item prop="weChat" :label=" $t('GA.WeChat') + ':'">
          <el-input v-model="formData.weChat"></el-input>
        </el-form-item>
        <el-form-item prop="whatsApp" :label="'WhatsApp' + ':'">
          <el-input v-model="formData.whatsApp"></el-input>
        </el-form-item>
        <!-- <div class="row"> 手机号
          <el-form-item prop="mobile" :label="$t('GA.mobile') + ':'">
            <el-input v-model="formData.mobile"></el-input>
            <span class="describe">{{$t('GA.requiredFields')}}</span>
          </el-form-item>
        </div>-->
        <!-- <div class="row"> 传真
          <el-form-item prop="fax" :label="$t('GA.fax') + ':'">
            <el-input v-model="formData.fax"></el-input>
            <span class="describe"></span>
          </el-form-item>
        </div>-->
        <!-- <div class="row"> QQ
          <el-form-item prop="qq" :label="'QQ:'">
            <el-input v-model="formData.qq"></el-input>
            <span class="describe"></span>
          </el-form-item>
        </div>-->
        <!-- <div class="row"> MSN
          <el-form-item prop="msn" :label="'MSN:'">
            <el-input v-model="formData.msn"></el-input>
            <span class="describe"></span>
          </el-form-item>
        </div>-->
        <!-- <div class="row"> SKYPE
          <el-form-item prop="skype" :label="'SKYPE:'">
            <el-input v-model="formData.skype"></el-input>
            <span class="describe"></span>
          </el-form-item>
        </div>-->
        <!-- <div class="row"> 雅虎
          <el-form-item prop="yahu" :label="$t('GA.Yahoo') + ':'">
            <el-input v-model="formData.yahu"></el-input>
            <span class="describe"></span>
          </el-form-item>
        </div>-->
        <!-- <div class="row"> 网站
          <el-form-item prop="website" :label="$t('GA.website') + ':'">
            <el-input v-model="formData.website"></el-input>
            <span class="describe"></span>
          </el-form-item>
        </div>-->
        <!-- <div class="row"> 地址
          <el-form-item prop="address" :label="$t('GA.address') + ':'">
            <el-input v-model="formData.address"></el-input>
            <span class="describe"></span>
          </el-form-item>
        </div>-->
        <!-- <div class="row"> 邮政编码
          <el-form-item prop="zipCode" :label="$t('GA.postalCode') + ':'">
            <el-input v-model="formData.zipCode"></el-input>
            <span class="describe"></span>
          </el-form-item>
        </div>-->
        <el-form-item prop="mobile" :label="$t('GA.mobile') + ':'">
          <el-input v-model="formData.mobile"></el-input>
        </el-form-item>
        <el-form-item prop="address" :label="$t('GA.address') + ':'">
          <el-input v-model="formData.address"></el-input>
          <span class="describe"></span>
        </el-form-item>
        <el-form-item prop="valideCode" :label="$t('GA.verifyCode') + ':'" required>
          <div style="display:flex;align-items:center">
            <el-input v-model="formData.valideCode" style="width:100%;margin-right:10px;"></el-input>
            <img
              v-if="JSON.stringify(codeData) !== '{}'"
              @click="getCode"
              :src="codeData.valideCode"
              title="看不清楚？换一张"
              style="border: 1px solid #e5e5e5;cursor: pointer;"
            />
          </div>
        </el-form-item>
      </el-form>
    </div>

    <span slot="footer">
      <div class="dialog-footer">
        <!-- <div>
          {{$t('GA.ExistingAccount')}} ?
          <span style="cursor: pointer;color:#f2410f;" @click="login">{{$t('GA.DirectLogin')}}</span>
        </div>-->
        <div>
          <el-button type="primary" @click="signInFun" class="btn">{{$hs("立即注册","Register") }}</el-button>
          <el-button type="primary" @click="close" class="btn btn_rest">{{ $hs('取消','Reset') }}</el-button>
        </div>
      </div>
    </span>
  </el-dialog>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import {
  GetValideCode,
  GetMemberSourceList,
  GetUserList,
  RegisterMember,
  VerifyEmail,
  IsExistUserAccount,
  RegisterByGuoAn
} from '@/api/login'
export default {
  name: 'loginModal',
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.formData.userPasswordVerify !== '') {
          this.$refs.formData.validateField('userPasswordVerify')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.formData.userPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      visible: false,
      codeData: {},
      formData: {
        gender: 0,
        source: '',
        job: '',
        company: '',
        tel: '',
        fax: '',
        qq: '',
        msn: '',
        skype: '',
        yahu: '',
        website: '',
        zipCode: '',
        country: '',
        userId: null,
        userAccount: '',
        userName: '',
        userPassword: '',
        userPasswordVerify: '',
        mobile: '',
        email: '',
        address: '',
        keyCode: 0,
        valideCode: '',
        weChat: '',
        whatsApp: ''
      },
      rules: {
        userName: [
          { required: true, message: '姓名为必填', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ],
        userPassword: [
          { validator: validatePass, trigger: 'blur' },
          { min: 6, max: 30, message: '长度在 6 到 30 个字符', trigger: 'blur' }
        ],
        userPasswordVerify: [{ validator: validatePass2, trigger: 'blur' }],

        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      },
      sourceList: [],
      userList: [],
      isUserAccount: false
    }
  },
  computed: {
    ...mapState('operate', ['language']),
    ...mapState('user', ['userInfo'])
  },
  methods: {
    ...mapActions('user', ['set_userInfo']),
    open() {
      this.visible = true
      this.getCode()
      this.getList()
    },

    close() {
      this.visible = false
      this.$refs.formData.resetFields()
    },

    sourceBlur(e) {
      this.formData.source = e.target.value
    },

    login() {
      this.close()
      this.$emit('login')
    },

    // 获取数据
    getList() {
      GetMemberSourceList()
        .then(res => {
          if (res.success) {
            this.sourceList = res.data || []
          }
        })
        .catch(err => {
          this.$message.error(err)
        })

      GetUserList()
        .then(res => {
          if (res.success) {
            this.userList = res.data || []
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },

    verifyEmailFun(memberId) {
      VerifyEmail({
        email: this.formData.email,
        memberId: memberId
      }).then(res => { })
    },

    userAccountBlur() {
      IsExistUserAccount({
        userAccount: this.formData.userAccount
      }).then(res => {
        if (res.data) {
          this.isUserAccount = true
          this.$message.warning(
            this.$hs(
              '用户名已存在',
              'User name already exists',
              'El nombre de usuario ya existe'
            )
          )
          this.$refs.userAccount.focus()
          this.$refs.userAccount.select()
        } else {
          this.isUserAccount = false
        }
      })
    },
    // 注册
    signInFun() {
      let _this = this
      _this.$refs.formData.validate(values => {
        if (!values) {
          this.$message.warning(
            this.$hs(
              '注册失败，校验不通过，请检查填写数据',
              'Registration failed, verification failed. Please check and fill in the data',
              'El registro falló, la verificación no pasó, por favor verifique y rellene los datos'
            )
          )
          return
        }
        // 注册
        RegisterByGuoAn({
          ..._this.formData,
          keyCode: _this.codeData.keyCode,
          userId: this.formData.userId ? this.formData.userId : 0,
          userAccount: this.formData.email
        })
          .then(res => {
            if (res.success) {
              _this.$message.success(_this.$t('regSuccess'))
              // _this.verifyEmailFun(res.data)
              _this.close()
            } else {
              _this.$message.error(res.message)
            }
          })
          .catch(err => {
            if (err.includes('D1632') || err.includes('D1631')) {
              _this.$message.error(
                _this.$hs(
                  '验证码不正确',
                  'Incorrect verification code',
                  'El Código de verificación no es correcto'
                )
              )
            } else if (err.includes('D1630')) {
              _this.$refs.inputEmail.focus()
              _this.$message.error(
                _this.$hs(
                  '该账号或邮箱已存在',
                  'The account or email already exists',
                  'La cuenta o buzón ya existe'
                )
              )
            }
            _this.getCode()
          })
      })
    },
    // 获取图形验证码
    getCode() {
      GetValideCode()
        .then(res => {
          this.codeData = res.data
        })
        .catch(err => {
          this.$message.error(err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.el-dialog__header) {
  text-align: left;
  padding: 0px;
  .el-dialog__headerbtn {
    z-index: 99;
  }
}
:deep(.el-dialog__body) {
  padding: 0 !important;
  .login-title {
    height: 62px;

    .title {
      height: 62px;
      line-height: 62px;
      text-align: left;
      font-size: 24px;
      color: #222222;
      margin-top: 30px;
      margin-left: 30px;
    }
    .msg {
      text-align: center;
      font-size: 14px;
      color: #999999;
    }
  }

  .form-box {
    height: 620px;
    padding: 20px;
    overflow-y: auto;

    .row {
      display: flex;
      align-items: center;
      .el-form-item {
        margin-bottom: 12px !important;

        .el-input {
          width: 350px;
        }
        .describe {
          padding: 0 0 0 10px;
          font-size: 14px;
          color: #666666;
        }
      }
    }
  }

  .operation {
    padding: 0 40px 30px;
    font-size: 14px;
    color: #222222;
    display: flex;
    justify-content: space-between;
  }
}

:deep(.el-dialog__footer) {
  padding: 10px 60px;
}
:deep .el-form {
  .valide-code {
    .el-input {
      margin: 0 10px 0 0;
    }
    .el-form-item__content {
      display: flex;
    }
  }
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  .btn {
    width: 140px;
    height: 42px;
    background: #ff0000;
    border: 1px solid #ff0000;
  }
  .btn_rest {
    background: #f4f4f4;
    border: 1px solid #e5e5e5;
    color: #999999;
  }
}

:deep(.el-form-item__error) {
  display: none;
}
:deep(.el-form-item__label) {
  padding-bottom: 5px;
}
:deep(.el-form-item) {
  margin-bottom: 10px !important;
}
</style>